import { Image, Input, Table, TableColumnsType } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {
  sortIcon,
  statusBadge,
  verificationStatusBadge,
} from "components/Table";
import { IDriver } from "models/driver";
import useDriverSearch from "hooks/drivers/useDriverSearch";
import { IFleet } from "models/fleet";

export default function DriverSearch() {
  const {
    data: { data, loading, search },
    handleSearch,
    handlePageChange,
  } = useDriverSearch();

  return (
    <div className="w-full">
      <div className="w-full px-6 flex flex-wrap-reverse">
        <div className="grow justify-between items-center flex-wrap-reverse gap-5"></div>
        <Input
          className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
          prefix={<SearchOutlined className="mr-2" />}
          placeholder="Search..."
          onChange={handleSearch}
          value={search}
        />
      </div>
      <div className="w-full mt-8 px-4">
        <Table
          loading={loading}
          columns={columns}
          dataSource={data}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
}

const columns: TableColumnsType<IDriver> = [
  {
    title: (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>No</div>
    ),
    render: (_, __, index) => {
      const number = index + 1;
      return <p className="text-base font-medium">{number}</p>;
    },
  },
  {
    title: "Driver Photo",
    dataIndex: "image",
    render: (image: string) => (
      <Image
        height={60}
        width={60}
        className="rounded object-cover"
        src={image}
        preview={false}
      />
    ),
  },
  {
    title: "Driver Name",
    sortIcon,
    sorter: (a, b) =>
      `${a.first_name} ${a.middle_name} ${a.last_name}`.localeCompare(
        `${b.first_name} ${b.middle_name} ${b.last_name}`
      ),
    render: (value: IDriver) => (
      <p>{`${value.first_name} ${value.middle_name} ${value.last_name}`}</p>
    ),
  },
  {
    title: "Phone Number",
    dataIndex: "phone",
    sortIcon,
    sorter: (a, b) => a.phone.localeCompare(b.phone),
  },
  {
    title: "Plate Number",
    dataIndex: "fleet",
    render: (fleet: IFleet) => <p>{fleet?.plate_number}</p>,
  },
  {
    title: "Verified",
    dataIndex: "is_verified",
    sortIcon,
    sorter: (a, b) =>
      a.is_verified === b.is_verified ? 0 : a.is_verified ? -1 : 1,
    render: verificationStatusBadge,
  },
  {
    title: "Active",
    dataIndex: "is_active",
    sortIcon,
    sorter: (a, b) => (a.is_active === b.is_active ? 0 : a.is_active ? -1 : 1),
    render: statusBadge,
  },
];
